// import React from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   IconButton,
//   InputBase,
//   Typography,
//   FormControl,
//   TextField,
// } from "@material-ui/core";
// import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
// import Autocomplete from "@material-ui/lab/Autocomplete";
// const ActivityTable = ({
//   classes,
//   invoiceData,
//   handleRemoveField,
//   handleChange,
//   handleNameChange,
//   inputRef,
//   items,
//   handleAddField,
//   styles,
// }) => {
//   return (
//     <div>
//       <TableContainer component={Paper} className="tb-container">
//         <Table className={classes.table} aria-label="simple table">
//           <TableHead>
//             <TableRow>
//               <TableCell align="center" style={{ fontSize: "20px" }}>Delete</TableCell>
//               <TableCell align="center" style={{ fontSize: "20px" }}>Particulars</TableCell>

//               <TableCell align="center" style={{ fontSize: "20px" }}>Unit</TableCell>
//               <TableCell align="center" style={{ fontSize: "20px" }}>Commission</TableCell>
//               <TableCell align="center" style={{ fontSize: "20px" }}>Income</TableCell>
//               <TableCell align="center" style={{ fontSize: "20px" }}>
//                 Amount
//               </TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {invoiceData?.map((itemField, index) => (
//               // console.log("itemField:", itemField), // Log the itemField object
//               // console.log("itemName:", itemField.itemName), // Log the itemName value
//               <TableRow key={index}>
//                 <TableCell align="center">
//                   <IconButton
//                     style={{ border: "1px solid red" }}
//                     onClick={() => handleRemoveField(index)}
//                   >
//                     <DeleteOutlineRoundedIcon
//                       style={{
//                         width: "20px",
//                         height: "20px",
//                         color: "red",
//                       }}
//                     />
//                   </IconButton>
//                 </TableCell>
//                 <TableCell
//                   align="center"
//                   style={{ cursor: "context-menu", fontSize: "18px" }}
//                 >
//                   {invoiceData[index].itemName}
//                   <div
//                     style={
//                       invoiceData[index].itemName
//                         ? { display: "none" }
//                         : { display: "block" }
//                     }
//                   >
//                     <FormControl variant="outlined" fullWidth>
//                       <Autocomplete
//                         options={items}
//                         getOptionLabel={(item) => item.itemName}
//                         value={items.itemName}
//                         onChange={(e, value) => {
//                           handleNameChange(index, value || "");
//                           inputRef.current.focus();
//                         }} // Modify this line
//                         renderInput={(params) => (
//                           <TextField
//                             {...params}
//                             variant="outlined"
//                             placeholder="Search Activity"
//                             fullWidth
//                             size="small"
//                           />
//                         )}
//                       />
//                     </FormControl>
//                   </div>
//                 </TableCell>

//                 {/* <TableCell
//                       align="center"
//                       style={{ cursor: "context-menu", fontSize: "18px" }}
//                     >
//                       {itemField.itemName ? (
//                         <span>

//                           {itemField.weight}
//                         </span>
//                       ) : (
//                         0
//                       )}
//                     </TableCell> */}
//                 <TableCell align="center" style={{ fontSize: "18px" }}>
//                   {" "}
//                   <InputBase
//                     inputRef={inputRef}
//                     sx={{ ml: 1, flex: 1, width: "10px" }}
//                     type="number"
//                     name="quantity"
//                     onChange={(e) => handleChange(index, e)}
//                     value={itemField.itemName ? itemField.quantity : "0"}
//                     placeholder="0"
//                     style={{
//                       fontSize: "18px",
//                       width: "50px",
//                       border: "1px solid grey",
//                       borderRadius: "5px",
//                       textAlign: "right",
//                     }}
//                     // autoFocus={itemField.itemName }
//                   />{" "}
//                 </TableCell>

//                 <TableCell
//                   align="center"
//                   style={{ cursor: "context-menu", fontSize: "18px" }}
//                 >
//                   {itemField.itemName ? (
//                     <span>
//                       {/* {getItemPrice(invoiceData.items[index].itemName)} */}
//                       {itemField?.commission?.commissionType === "1"
//                         ? (itemField?.commission?.commissionValue / 100) *
//                           itemField.unitPrice
//                         : itemField?.commission?.commissionValue}
//                     </span>
//                   ) : (
//                     0
//                   )}
//                 </TableCell>
//                 <TableCell
//                   align="center"
//                   style={{ cursor: "context-menu", fontSize: "18px" }}
//                 >
//                   {itemField.itemName ? (
//                     <span>
//                       {/* {getItemPrice(invoiceData.items[index].itemName)} */}
//                       {itemField.unitPrice}
//                     </span>
//                   ) : (
//                     0
//                   )}
//                 </TableCell>

//                 <TableCell align="center">
//                   {" "}
//                   <InputBase
//                     sx={{ ml: 1, flex: 1 }}
//                     type="number"
//                     name="amount"
//                     onChange={(e) => handleChange(index, e)}
//                     value={itemField.quantity * itemField.unitPrice}
//                     disabled
//                     style={{ fontSize: "18px", display: "none" }}
//                   />{" "}
//                   <Typography variant="h5" color="initial">
//                     {itemField.quantity *
//                       itemField?.commission?.commissionValue || 0}
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <div className={styles.addButton}>
//         <button
//           onClick={handleAddField}
//           style={{ backgroundColor: "#ef7f1a", color: "white" }}
//           // disabled={scanning}
//         >
//           +
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ActivityTable;

import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  InputBase,
  Typography,
  FormControl,
  TextField,
} from "@material-ui/core";

import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import Autocomplete from "@material-ui/lab/Autocomplete";

const ActivityTable = ({
  classes,
  invoiceData,
  handleRemoveField,
  handleChange,
  handleNameChange,
  inputRef,
  items,
  handleAddField,
  handleQuantityChange,
  styles,
}) => {
  return (
    <div>
      <TableContainer
        component={Paper}
        className="tb-container"
        style={{
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell
                align="center"
                style={{ fontSize: "18px", fontWeight: "bold" }}
              >
                Delete
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: "18px", fontWeight: "bold" }}
              >
                Particulars
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: "18px", fontWeight: "bold" }}
              >
                Unit
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: "18px", fontWeight: "bold" }}
              >
                Commission
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: "18px", fontWeight: "bold" }}
              >
                Income
              </TableCell>

              <TableCell
                align="center"
                style={{ fontSize: "18px", fontWeight: "bold" }}
              >
                Amount
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {invoiceData?.map((itemField, index) => (
              <TableRow key={index}>
                {/* DELETE */}

                <TableCell align="center">
                  <IconButton
                    onClick={() => handleRemoveField(index)}
                    style={{
                      border: "1px solid red",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    <DeleteOutlineRoundedIcon
                      style={{
                        color: "red",
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </IconButton>
                </TableCell>

                {/* PARTICULAR */}

                <TableCell align="center">
                  {itemField.itemName ? (
                    <span style={{ fontSize: "17px" }}>
                      {itemField.itemName}
                    </span>
                  ) : (
                    <FormControl variant="outlined" fullWidth>
                      <Autocomplete
                        options={items}
                        getOptionLabel={(item) => item.itemName}
                        onChange={(e, value) => {
                          handleNameChange(index, value || "");

                          inputRef.current.focus();
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Search Activity"
                            size="small"
                          />
                        )}
                      />
                    </FormControl>
                  )}
                </TableCell>

                {/* UNIT WITH COUNTER */}

                <TableCell align="center">
                  <div
                    style={{
                      display: "flex",

                      justifyContent: "center",

                      alignItems: "center",

                      gap: "8px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => handleQuantityChange(index, "dec")}
                      style={{
                        width: "30px",

                        height: "30px",

                        borderRadius: "50%",

                        border: "1px solid #ef7f1a",

                        background: "white",

                        color: "#ef7f1a",

                        fontSize: "18px",

                        cursor: "pointer",
                      }}
                    >
                      -
                    </button>

                    <InputBase
                      inputRef={inputRef}
                      type="number"
                      name="quantity"
                      value={itemField.quantity || 0}
                      onChange={(e) => handleChange(index, e)}
                      style={{
                        width: "45px",

                        height: "32px",

                        border: "1px solid #ccc",

                        borderRadius: "6px",

                        textAlign: "center",

                        fontSize: "16px",

                        paddingLeft: "8px",
                      }}
                    />

                    <button
                      type="button"
                      onClick={() => handleQuantityChange(index, "inc")}
                      style={{
                        width: "30px",

                        height: "30px",

                        borderRadius: "50%",

                        border: "1px solid #ef7f1a",

                        background: "#ef7f1a",

                        color: "white",

                        fontSize: "18px",

                        cursor: "pointer",
                      }}
                    >
                      +
                    </button>
                  </div>
                </TableCell>

                {/* COMMISSION */}

                <TableCell align="center">
                  <Typography variant="body1">
                    {itemField?.commission?.commissionType === "1"
                      ? (itemField?.commission?.commissionValue / 100) *
                        itemField.unitPrice
                      : itemField?.commission?.commissionValue || 0}
                  </Typography>
                </TableCell>

                {/* INCOME */}

                <TableCell align="center">
                  <Typography variant="body1">
                    {itemField.unitPrice || 0}
                  </Typography>
                </TableCell>

                {/* AMOUNT */}

                <TableCell align="center">
                  <Typography variant="h6">
                    {itemField.quantity *
                      itemField?.commission?.commissionValue || 0}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div className={styles.addButton}>
        <button
          type="button"
          onClick={handleAddField}
          style={{
            backgroundColor: "#ef7f1a",

            color: "white",

            border: "none",

            width: "40px",

            height: "40px",

            borderRadius: "50%",

            fontSize: "25px",

            cursor: "pointer",
          }}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default ActivityTable;
